import React from 'react'
import { ArrowLeftIcon, ArrowRightIcon } from '@mote/assets/icons'
import { dataAttr } from '@mote/helpers'
import styled, { th } from '@xstyled/styled-components'
import { Block } from '../../block/block'
import { Button, IconButton } from '../../button'
import { Text } from '../../typography/text'
import { useDataTable } from '../dataTable.context'

export const DataTablePaginator = () => {
  const {
    table,
    onPageChange,
    isManualPagination,
    data: { pages }
  } = useDataTable()

  if (table.getPageCount() < 2) {
    return null
  }

  return (
    <Block layout='horizontal' align='center' justify='space-between' gap={12}>
      <Text
        tag='span'
        fontSize={14}
        fontWeight={400}
        lineHeight='120%'
        color='grey.d2'
      >
        Showing {table.getState().pagination.pageIndex + 1} of{' '}
        {table.getPageCount()}
      </Text>
      <Block layout='horizontal'>
        {table.getCanPreviousPage() && (
          <IconButton
            variant='ghost'
            icon={<ArrowLeftIcon />}
            onClick={() => {
              table.previousPage()
              onPageChange(table.getState().pagination.pageIndex - 1)
            }}
          />
        )}
        {isManualPagination
          ? pages.map((page, id) => {
              const [pageNumber, label] = Array.isArray(page)
                ? page
                : [page, page]
              const isCurrentOrEllipsis = pageNumber === '...'
              const isActivePage =
                pageNumber - 1 === table.getState().pagination.pageIndex

              return (
                <React.Fragment key={`${pageNumber}-${label}-${id}`}>
                  {isActivePage && (
                    <NonPageNumber data-active={dataAttr(isActivePage)}>
                      {label}
                    </NonPageNumber>
                  )}
                  {isCurrentOrEllipsis && (
                    <NonPageNumber>{pageNumber}</NonPageNumber>
                  )}
                  {!(isCurrentOrEllipsis || isActivePage) && (
                    <PageButton
                      variant='ghost'
                      onClick={() => {
                        table.setPageIndex(pageNumber - 1)
                        onPageChange(pageNumber - 1)
                      }}
                      text={label ?? pageNumber}
                      pill
                    />
                  )}
                </React.Fragment>
              )
            })
          : null}
        {table.getCanNextPage() && (
          <IconButton
            variant='ghost'
            icon={<ArrowRightIcon />}
            onClick={() => {
              table.nextPage()
              onPageChange(table.getState().pagination.pageIndex + 1)
            }}
          />
        )}
      </Block>
    </Block>
  )
}

const PageButton = styled(Button)`
  padding: 0;
  width: 40px;
`

const NonPageNumber = styled.span`
  display: inline-flex;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-align: center;
  font-size: 15px;
  color: black;
  flex: 0 0 auto;
  justify-content: center;
  align-items: center;
  cursor: default;
  user-select: none;
  touch-action: manipulation;
  outline-offset: 2px;
  border-radius: 99999px;
  border: none;
  height: 40px;
  width: 40px;
  text-decoration: none;
  box-sizing: border-box;
  white-space: nowrap;
  vertical-align: middle;
  background: transparent;
  outline: transparent solid 2px !important;

  &[data-active] {
    background: ${th.color('grey.l4')};
  }
`
